(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["marcha-gift-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('marcha-gift-card')) {
    customElements.define('marcha-gift-card', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const select = this.querySelector('select');
        const image = this.querySelector('img');
        select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          image.hidden = !option.dataset.image;
          if (option.dataset.image) image.src = option.dataset.image;
          image.alt = option.textContent.trim();
        });
        this.querySelector('form').addEventListener('submit', () => {
          this.querySelector('button').disabled = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marcha-unlock-gift"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('marcha-unlock-gift')) {
  class MarchaUnlockGift extends HTMLElement {
    static instances = new Set();
    static busy = false;
    static pending = null;
    static cart = null;
    static initialized = false;
    connectedCallback() {
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.unit = 100 / Number(this.dataset.moneySample);
      this.baseline = new Set();
      this.dirty = false;
      this.addEventListener('change', () => { this.dirty = true; this.limitSelection(); });
      this.querySelector('.mug-save').addEventListener('click', () => this.save());
      this.querySelector('.mug-clear').addEventListener('click', () => {
        this.querySelectorAll('input').forEach(box => { box.checked = false; });
        this.dirty = true;
        this.save();
      });
      this.querySelector('[data-picker]').addEventListener('toggle', () => {
        if (this.querySelector('[data-picker]').open) this.sync();
      });
      MarchaUnlockGift.instances.add(this);
      if (!MarchaUnlockGift.initialized) {
        MarchaUnlockGift.initialized = true;
        if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, () => MarchaUnlockGift.refresh());
        window.addEventListener('pageshow', () => MarchaUnlockGift.refresh());
        window.addEventListener('focus', () => MarchaUnlockGift.refresh());
        document.addEventListener('click', event => {
          if (event.target.closest('[name="checkout"]') && MarchaUnlockGift.busy) {
            event.preventDefault(); event.stopImmediatePropagation();
          }
        }, true);
      }
      if (MarchaUnlockGift.cart) this.paint(MarchaUnlockGift.cart);
      if (!MarchaUnlockGift.busy) this.sync();
    }
    disconnectedCallback() { MarchaUnlockGift.instances.delete(this); }
    static refresh() {
      const instance = [...this.instances].find(el => el.isConnected);
      if (instance) return instance.sync();
    }
    async request(path, body) {
      const response = await fetch(this.dataset.root + path, body ? {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(body)
      } : {headers:{'Accept':'application/json'},cache:'no-store'});
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || this.strings.error);
      return data;
    }
    state(cart) {
      const rewards = cart.items.filter(item => String(item.product_id) === this.dataset.product);
      const spend = cart.items.filter(item => String(item.product_id) !== this.dataset.product && String(item.product_id) !== this.dataset.card && item.product_type !== 'Marcha Reward').reduce((sum,item) => sum + item.final_line_price,0);
      const amount = spend / this.unit;
      const allowance = amount >= 83 ? 3 : amount >= 63 ? 2 : amount >= 50 ? 1 : 0;
      return {amount,allowance,rewards,count:rewards.reduce((sum,item) => sum + item.quantity,0)};
    }
    lock(on) {
      MarchaUnlockGift.busy = on;
      document.querySelectorAll('[name="checkout"]').forEach(button => {
        if (on && !button.disabled) {button.disabled = true; button.dataset.mugLocked = 'true';}
        else if (!on && button.dataset.mugLocked) {button.disabled = false; delete button.dataset.mugLocked;}
      });
      MarchaUnlockGift.instances.forEach(el => {el.setAttribute('aria-busy',String(on)); el.limitSelection();});
    }
    async normalize(cart) {
      const state = this.state(cart);
      const updates = {};
      const seen = new Set();
      let kept = 0;
      for (const item of state.rewards) {
        const quantity = kept < state.allowance && !seen.has(item.variant_id) ? 1 : 0;
        if (quantity) {kept++; seen.add(item.variant_id);}
        if (quantity !== item.quantity) updates[item.key] = quantity;
      }
      let changed = Object.keys(updates).length > 0;
      if (changed) cart = await this.request('cart/update.js',{updates});
      const paidRewards = this.state(cart).rewards.filter(item => item.final_line_price !== 0);
      if (paidRewards.length) {
        cart = await this.request('cart/update.js',{updates:Object.fromEntries(paidRewards.map(item => [item.key,0]))});
        changed = true;
      }
      return {cart,changed,charged:paidRewards.length > 0};
    }
    async sync() {
      if (MarchaUnlockGift.busy) return;
      if (MarchaUnlockGift.pending) return MarchaUnlockGift.pending;
      MarchaUnlockGift.pending = (async () => {
        try {
          this.lock(true);
          const result = await this.normalize(await this.request('cart.js'));
          MarchaUnlockGift.cart = result.cart;
          if (result.changed) await this.renderCart();
          MarchaUnlockGift.instances.forEach(el => {
            el.paint(result.cart);
            if (result.changed) el.feedback(result.charged ? el.strings.not_free : el.strings.adjusted,result.charged);
          });
        } catch (error) { this.feedback(error.message,true); }
        finally { this.lock(false); MarchaUnlockGift.pending = null; }
      })();
      return MarchaUnlockGift.pending;
    }
    paint(cart) {
      const state = this.state(cart);
      const previousAllowance = this.allowance;
      this.allowance = state.allowance;
      this.baseline = new Set(state.rewards.map(item => String(item.variant_id)));
      if (!this.dirty || previousAllowance !== this.allowance) {
        this.querySelectorAll('input').forEach(box => {box.checked = this.baseline.has(box.value);});
        this.dirty = false;
      }
      this.querySelector('[data-count]').textContent = this.strings.chosen.replace('[count]',state.count).replace('[total]',state.allowance);
      const thresholds = [50,63,83];
      const nextIndex = thresholds.findIndex(value => state.amount < value);
      const previous = nextIndex > 0 ? thresholds[nextIndex-1] : 0;
      const node = this.querySelector('[data-progress-text]');
      const progress = this.querySelector('progress');
      node.replaceChildren();
      if (nextIndex < 0) {
        node.textContent = this.strings.maximum;
        progress.max = 1;
        progress.value = 1;
      } else {
        const amount = new Intl.NumberFormat('en',{maximumFractionDigits:3}).format(Math.max(0,Math.round((thresholds[nextIndex]-state.amount)*1000)/1000));
        const message = this.strings.remaining.replace('[count]',String(nextIndex+1));
        const parts = message.split('[amount]');
        node.append(document.createTextNode(parts[0]));
        const highlight = document.createElement('strong');
        highlight.className = 'mug-amount';
        highlight.textContent = amount + ' KWD';
        node.append(highlight,document.createTextNode(parts[1] || ''));
        progress.max = thresholds[nextIndex]-previous;
        progress.value = Math.max(0,state.amount-previous);
      }
      progress.setAttribute('aria-valuetext',node.textContent);
      this.limitSelection();
    }
    selected() {return [...this.querySelectorAll('input:checked')].map(box => box.value);}
    limitSelection() {
      if (!this.baseline) return;
      const boxes = [...this.querySelectorAll('input[type="checkbox"]')];
      const allowance = this.allowance || 0;
      const total = this.selected().length;
      const changed = total !== this.baseline.size || this.selected().some(id => !this.baseline.has(id));
      boxes.forEach(box => {box.disabled = MarchaUnlockGift.busy || (!box.checked && total >= allowance);});
      const save = this.querySelector('.mug-save');
      save.disabled = MarchaUnlockGift.busy || !changed || total > allowance;
      save.textContent = MarchaUnlockGift.busy ? this.strings.saving : this.baseline.size ? this.strings.save : this.strings.add;
      this.querySelector('.mug-clear').disabled = MarchaUnlockGift.busy || (!total && !this.baseline.size);
      if (this.dirty) this.querySelector('[data-count]').textContent = this.strings.chosen.replace('[count]',total).replace('[total]',allowance);
    }
    feedback(message,error=false) {
      const node = this.querySelector('[data-feedback]');
      node.textContent = message;
      node.hidden = false;
      node.classList.toggle('mug-error',error);
    }
    async renderCart() {
      const sections = ['cart-drawer','cart-icon-bubble'];
      const targets = [
        {section:'cart-drawer',selector:'#CartDrawer .drawer__inner'},
        {section:'cart-icon-bubble',selector:'#cart-icon-bubble'}
      ];
      for (const id of ['main-cart-items','main-cart-footer']) {
        const element = document.getElementById(id);
        if (element?.dataset.id) {sections.push(element.dataset.id); targets.push({section:element.dataset.id,selector:'#'+id});}
      }
      const response = await fetch(window.location.pathname+'?sections='+sections.map(encodeURIComponent).join(','),{cache:'no-store'});
      if (!response.ok) throw new Error(this.strings.error);
      const html = await response.json();
      for (const target of targets) {
        const current = document.querySelector(target.selector);
        const source = html[target.section] && new DOMParser().parseFromString(html[target.section],'text/html').querySelector(target.selector);
        if (current && source) {current.innerHTML = source.innerHTML; current.className = source.className;}
      }
      const drawer = document.querySelector('cart-drawer');
      drawer?.classList.toggle('is-empty',MarchaUnlockGift.cart.item_count === 0);
      document.querySelector('cart-items')?.classList.toggle('is-empty',MarchaUnlockGift.cart.item_count === 0);
      if (drawer?.classList.contains('active') && typeof trapFocus === 'function') trapFocus(document.getElementById('CartDrawer'),drawer.querySelector('.mug-trigger') || drawer.querySelector('.drawer__close'));
    }
    async save() {
      if (MarchaUnlockGift.busy) return;
      const desired = this.selected();
      const context = this.dataset.context;
      try {
        this.lock(true);
        let cart = await this.request('cart.js');
        let state = this.state(cart);
        if (desired.length > state.allowance) throw new Error(this.strings.changed);
        const updates = {};
        const kept = new Set();
        for (const item of state.rewards) {
          const id = String(item.variant_id);
          const quantity = desired.includes(id) && !kept.has(id) ? 1 : 0;
          if (quantity) kept.add(id);
          if (quantity !== item.quantity) updates[item.key] = quantity;
        }
        if (Object.keys(updates).length) cart = await this.request('cart/update.js',{updates});
        const additions = desired.filter(id => !kept.has(id));
        if (additions.length) await this.request('cart/add.js',{items:additions.map(id => ({id:Number(id),quantity:1,properties:{_marcha_reward:'luggage'}}))});
        const result = await this.normalize(await this.request('cart.js'));
        MarchaUnlockGift.cart = result.cart;
        MarchaUnlockGift.instances.forEach(el => {el.dirty = false;});
        await this.renderCart();
        MarchaUnlockGift.instances.forEach(el => {
          el.paint(result.cart);
          el.querySelector('[data-picker]').open = false;
          el.feedback(result.charged ? el.strings.not_free : el.strings.saved,result.charged);
        });
        [...MarchaUnlockGift.instances].find(el => el.dataset.context === context)?.querySelector('.mug-trigger').focus();
      } catch (error) {
        this.feedback(error.message,true);
        try {
          MarchaUnlockGift.cart = await this.request('cart.js');
          await this.renderCart();
          MarchaUnlockGift.instances.forEach(el => {el.dirty=false; el.paint(MarchaUnlockGift.cart); el.feedback(error.message,true);});
        } catch (_) {}
      } finally { this.lock(false); }
    }
  }
  customElements.define('marcha-unlock-gift',MarchaUnlockGift);
}
  } catch(e) { console.error(e); }
})();

})();
